

@if (timing) {
  <div class="timing-item-solo">
    <div class="icon" [ngClass]="{'light': findIndexTiming(timing)%2 == 0, 'dark': findIndexTiming(timing)%2 != 0}">
      <img [src]="findIconTiming(timing)" [alt]="timing.descricao" [title]="timing.descricao"/>
    </div>
    <p class="title">{{timing.descricao}}</p>
    <app-button [customStyle]="'border: 1px solid #007AC2; color: #007AC2 !important; background: white'"
    [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(timing)"></app-button>
  </div>
}
@if (!timing) {
  <div id="container-cards-timing">
    @for (item of timings; track item; let i = $index) {
      <div class="timing-item">
        <div class="icon-name">
          <div class="icon" [ngClass]="{'light': i%2 == 0, 'dark': i%2 != 0}">
            <img [src]="findIconTiming(item)" [alt]="item.descricao" [title]="item.descricao"/>
          </div>
          <p class="title">{{item.descricao}}</p>
        </div>
        <app-button [customStyle]="'border: 1px solid #007AC2; color: #007AC2; background: white'"
        [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(item)"></app-button>
      </div>
    }
  </div>
}


